import { Component, EventEmitter, Output } from '@angular/core';
import { ExerciseService } from 'src/services/exercise-service.service';
import { Auth, authState } from '@angular/fire/auth';
import { firstValueFrom } from 'rxjs';
import { CreateExercise, Exercise } from 'src/models/exercise.model';

@Component({
    selector: 'app-add-exercise',
    templateUrl: './add-exercise.component.html',
    styleUrls: ['./add-exercise.component.scss'],
    standalone: false
})
export class AddExerciseComponent {
  @Output() exerciseAdded = new EventEmitter<string>(); // Use <any> or a specific type for the event payload
  @Output() closeView = new EventEmitter<any>();

  constructor(private exerciseService: ExerciseService, private auth: Auth) {}

  loading = false;
  async addExercise(data: CreateExercise) {
    this.loading = true;

    const user = await firstValueFrom(authState(this.auth));
    if (user) {
      let imageUrl = '';
      if (data.selectedFile) {
        imageUrl = await this.exerciseService.uploadImage(
          data.selectedFile,
          user.uid
        );
      } else if (data.imagePreview) {
        // Assuming this.selectedImageUrl is the URL of the selected GIF
        imageUrl = await this.exerciseService.uploadImageFromUrl(
          data.imagePreview as string,
          user.uid
        );
      }

      // Collecting selected muscle groups from the toggleStates map
      const selectedHashtags = Array.from(data.toggleStates.entries())
        .filter(([group, toggled]) => toggled)
        .map(([group]) => group);

      const selectedSecondaryHashtags = Array.from(
        data.secondaryToggleStates.entries()
      )
        .filter(([group, toggled]) => toggled)
        .map(([group]) => group);

      const exercise: Exercise = {
        userId: user.uid,
        sportName: data.sportName,
        description: data.description,
        hashtags: selectedHashtags,
        secondaryHashtags: selectedSecondaryHashtags,
        imageUrl: imageUrl,
      };

      const docRef = await this.exerciseService.addExercise(exercise);

      this.exerciseAdded.emit(docRef.id);
      this.closeView.emit();
      console.log('Exercise added successfully');
      this.loading = false;
      // Reset form or provide user feedback here
    }
  }
}
